import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22 5a4 4 0 0 1-6.878 2.778l-5.418 2.709c.19.466.296.977.296 1.513 0 .544-.109 1.064-.306 1.537l5.15 3.004a4 4 0 1 1-.685 1.337L8.866 14.79a4 4 0 1 1 .012-5.568l5.418-2.709A4 4 0 1 1 22 5m-4 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m-12 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M20.5 19a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }